import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { renderTrialsMessage } from '../../lib/date';
import moment from 'moment';

class TrialsInfo extends Component {
  render() {
    const { trialEndsAt } = this.props;
    const parsedTrialsEnd = moment(trialEndsAt).format('YYYY-MM-DD');

    return (
      <Fragment>{renderTrialsMessage(new Date(), trialEndsAt) ? <div className={ 'trials-end' }>
        <i aria-hidden='true' className='fa fa-exclamation-triangle trials-end__icon' />
        <div className={ 'trials-end__content' }>
          <div className={ 'trials-end__text' }>
                        Your trial will end {parsedTrialsEnd}
          </div>
        </div>
      </div> : null
      }
      </Fragment>
    );
  }
}

TrialsInfo.propTypes = {
  trialEndsAt: PropTypes.string
};

const mapStateToProps = (state) => {
  return {
    trialEndsAt: state.getIn(['currentUser', 'data', 'trialEndsAt'])
  };
};

export default connect(mapStateToProps)(TrialsInfo);



// WEBPACK FOOTER //
// ./app/components/reps/TrialsInfo.jsx